// The API, the uploads and this SPA are all served from one origin, so these are
// root-relative by default and no CORS preflight happens. Set REACT_APP_API_ORIGIN at
// build time only to point a build at a different backend (for example a staging box).
const API_ORIGIN = process.env.REACT_APP_API_ORIGIN || ""

export const BASE_URL = `${API_ORIGIN}/api`
export const FILES_URL = `${API_ORIGIN}/uploads/`

// Laravel web route, so it sits outside the /api prefix.
export const BARCODE_PROXY_URL = `${API_ORIGIN}/barcode-proxy`

//REGISTER
export const POST_FAKE_REGISTER = "/post-fake-register";

//LOGIN
export const POST_JWT_LOGIN = BASE_URL + "/auth/login";
export const CHECK_JWT_TOKEN = BASE_URL + "/auth/check-token";

//REPORTS
export const GET_REPORTS = BASE_URL + "/reports";
export const GET_OPTIONAL_REPORTS = BASE_URL + "/reports/optional";
export const GET_REPORTS_FOR_LOCATION = BASE_URL + "/reports/location";
export const GET_COREPARK_REPORT = BASE_URL + "/reports/corepark";
export const GET_COREPARK_TICKETS_REPORT = BASE_URL + "/reports/corepark-tickets";
export const GET_SPOTHERO_REPORT = BASE_URL + "/reports/spothero";
export const GET_RESOLVE_REPORT = BASE_URL + "/reports/resolve";
export const GET_LEASEPAYMENT_REPORT = BASE_URL + "/reports/lease-payments";
export const GET_MONTHLYPARKING_REPORT = BASE_URL + "/reports/monthly-parking";
export const GET_MONTHLYPARKING_EXPORT_REPORT_TEMPLATES = BASE_URL + "/reports/monthly-parking-export-templates";
export const ADD_MONTHLYPARKING_EXPORT_REPORT_TEMPLATE = BASE_URL + "/reports/monthly-parking-export-templates";
export const DELETE_MONTHLYPARKING_EXPORT_REPORT_TEMPLATE = BASE_URL + "/reports/monthly-parking-export-templates/delete";
export const GET_FEE_REPORT = BASE_URL + "/reports/fees";
export const GET_COST_REPORT = BASE_URL + "/reports/costs";
export const GET_SUREPARK_REPORT = BASE_URL + "/reports/surepark";
export const GET_AMANO_REPORT = BASE_URL + "/reports/amano";
export const GET_EVENTS_REPORT = BASE_URL + "/reports/events";
export const IMPORT_AMANO_REPORT = BASE_URL + "/amano/import-csv";
export const IMPORT_SPOTHERO_REPORT = BASE_URL + "/spothero/import-csv";
export const IMPORT_SUREPARK_REPORT = BASE_URL + "/surepark/import-csv";
export const IMPORT_RESOLVE_REPORT = BASE_URL + "/resolve/import-csv";
export const SQUARE_TRANSACTIONS_REPORT = BASE_URL + "/square/get-transactions";
// export const EDIT_ANNOUNCE = BASE_URL + "/system-configs/announce";

//CHANGES
export const MAKE_CHANGE = BASE_URL + "/changes";
export const GET_CHANGES = BASE_URL + "/changes";

//DEVELOPER TICKETS
export const GET_DEVELOPER_TICKETS = BASE_URL + "/developer-tickets";
export const ADD_DEVELOPER_TICKET = BASE_URL + "/developer-tickets";

//PAYMENTS
export const ADD_LEASE_PAYMENT = BASE_URL + "/payments/lease-payments";
export const EDIT_LEASE_PAYMENT = BASE_URL + "/payments/lease-payments";
export const DELETE_LEASE_PAYMENT = BASE_URL + "/payments/lease-payments";
export const ADD_FEE = BASE_URL + "/payments/fees";
export const EDIT_FEE = BASE_URL + "/payments/fees";
export const DELETE_FEE = BASE_URL + "/payments/fees";
export const ADD_COST = BASE_URL + "/payments/costs";
export const EDIT_COST = BASE_URL + "/payments/costs";
export const DELETE_COST = BASE_URL + "/payments/costs";
export const ADD_MONTHLY_PARKING_SUBSCRIPTION = BASE_URL + "/payments/monthly-parking/subscriptions";
export const MONTHLY_PARKING_PAY_FOR_ORDER = BASE_URL + "/payments/monthly-parking/orders";
export const UPDATE_MONTHLY_PARKING = BASE_URL + "/payments/monthly-parking";
export const UPDATE_MONTHLY_PARKING_SUBSCRIPTION = BASE_URL + "/payments/monthly-parking/subscriptions";
export const CREATE_MONTHLY_PARKING_SUBSCRIPTION_PENDING_RENEWAL_ORDER = BASE_URL + "/payments/monthly-parking/subscriptions";
export const DELETE_MONTHLY_PARKING = BASE_URL + "/payments/monthly-parking";
export const LICENCE_PLATE_CHECK = BASE_URL + "/payments/licence-plate-check";
export const GET_ALL_DAILY_PRODUCT_REPORTS = BASE_URL + "/payments/all-daily-product-transactions";

//SYSTEM CONFIGS
export const GET_ANNOUNCE = BASE_URL + "/system-configs/announce";
export const EDIT_ANNOUNCE = BASE_URL + "/system-configs/announce";

//CONTENT BOXES
export const GET_CONTENT_BOXES = BASE_URL + "/content-boxes";
export const ADD_CONTENT_BOX = BASE_URL + "/content-boxes";
export const EDIT_CONTENT_BOX = BASE_URL + "/content-boxes/edit";
export const DELETE_CONTENT_BOX = BASE_URL + "/content-boxes/delete";
export const ORDER_CONTENT_BOX = BASE_URL + "/content-boxes/order";

//ONBOARDING STEPS
export const GET_ONBOARDING_STEPS = BASE_URL + "/onboarding-steps";
export const CHECK_ONBOARDING_STATE = BASE_URL + "/users/check-onboarding-state";
export const UPLOAD_DRIVER_LICENSE = BASE_URL + "/users/upload-driver-license";
export const UPDATE_DRIVER_LICENSE_INFORMATION = BASE_URL + "/users/update-driver-license-information";
export const UPDATE_SSN_INFORMATION = BASE_URL + "/users/update-ssn-information";
export const UPDATE_PASSPORT_INFORMATION = BASE_URL + "/users/update-passport-information";
export const UPDATE_GREEN_CARD_INFORMATION = BASE_URL + "/users/update-green-card-information";
export const UPDATE_EAD_INFORMATION = BASE_URL + "/users/update-ead-information";
export const SIGN_PDF = BASE_URL + "/users/sign-pdf";
export const FINISH_ONBOARDING = BASE_URL + "/users/finish-onboarding";
export const UPLOAD_SSN_FILE = BASE_URL + "/users/upload-ssn-file";
export const UPLOAD_ITIN_LETTER = BASE_URL + "/users/upload-itin-letter";
export const UPLOAD_BIRTH_CERTIFICATE = BASE_URL + "/users/upload-birth-certificate";
export const UPLOAD_PASSPORT_FILE = BASE_URL + "/users/upload-passport-file";
export const UPLOAD_GREEN_CARD = BASE_URL + "/users/upload-green-card";
export const UPLOAD_EAD_CARD = BASE_URL + "/users/upload-ead-card";
export const UPDATE_USER_ONBOARDING_CONFIG = BASE_URL + "/users/update-user-onboarding-configs";
export const UPLOAD_SIGNED_DOCUMENT = BASE_URL + "/users/upload-signed-document";
export const PREPARE_FILLED_EMPLOYEE_WITHHOLDING_ALLOWANCE_CERTIFICATE = BASE_URL + "/pdfs/prepare-filled-employee-withholding-allowance-certificate";

//USER
export const EDIT_PROFILE_PICTURE = BASE_URL + "/users/me/update-profile-picture";
export const EDIT_PASSWORD = BASE_URL + "/auth/change-password";
export const COMPLETE_COURSE_CONTENT = BASE_URL + "/users/courses/contents";
export const USER_COURSES = BASE_URL + "/users/courses";
export const GET_USERS = BASE_URL + "/users";
export const ADD_USER = BASE_URL + "/users";
export const EDIT_USER = BASE_URL + "/users/edit";
export const DELETE_USER = BASE_URL + "/users/delete";
export const GET_ACCOUNT_MANAGERS = BASE_URL + "/users/account-managers";

//COURSES
export const GET_COURSES = BASE_URL + "/courses";
export const ADD_COURSE = BASE_URL + "/courses";
export const ADD_COURSE_CONTENT = BASE_URL + "/courses/contents";
export const DELETE_COURSE_CONTENT = BASE_URL + "/courses/contents/delete";
export const EDIT_COURSE_CONTENT = BASE_URL + "/courses/contents/edit";
export const EDIT_COURSE = BASE_URL + "/courses/edit";
export const DELETE_COURSE = BASE_URL + "/courses/delete";

//CALENDAR
export const GET_COLORED_DATES = BASE_URL + "/colored-dates";
export const ADD_COLORED_DATE = BASE_URL + "/colored-dates";
export const GET_EVENT_CATEGORIES = BASE_URL + "/events/categories";
export const ADD_EVENT_CATEGORY = BASE_URL + "/events/categories";
export const DELETE_EVENT_CATEGORY = BASE_URL + "/events/categories/delete";
export const EDIT_EVENT_CATEGORY = BASE_URL + "/events/categories/edit";

//FILES
export const UPLOAD_IMAGE = BASE_URL + "/files/upload-image";
export const UPLOAD_FILE = BASE_URL + "/files/upload-file";

//TEAMS
export const GET_TEAMS = BASE_URL + "/teams";
export const ADD_TEAM = BASE_URL + "/teams";
export const EDIT_TEAM = BASE_URL + "/teams/edit";
export const DELETE_TEAM = BASE_URL + "/teams/delete";

//EVENTS
export const GET_EVENTS = BASE_URL + "/events";
export const ADD_EVENT = BASE_URL + "/events";
export const IMPORT_EVENTS = BASE_URL + "/events/import";
export const EDIT_EVENT = BASE_URL + "/events";
export const DELETE_EVENT = BASE_URL + "/events";

//LOCATIONS
export const GET_LOCATIONS = BASE_URL + "/locations";
export const GET_LOCATION = BASE_URL + "/locations";
export const EDIT_LOCATION = BASE_URL + "/locations";
export const EDIT_BULK_LOCATIONS = BASE_URL + "/locations/bulk-edit";
export const ADD_LOCATION = BASE_URL + "/locations";

//EMPLOYEES
export const IMPORT_PROSPR_EMPLOYEE = BASE_URL + "/employees/prospr/import";
export const IMPORT_LABOR_SPREADSHEET_EMPLOYEE = BASE_URL + "/employees/labor-spreadsheet/import";
export const GET_LABOR_REPORT = BASE_URL + "/employees/labor/report";

//THIRD PARTY PLATFORMS
export const GET_THIRD_PARTY_PLATFORMS = BASE_URL + "/third-party-platforms";

//PARKING TYPES
export const GET_PARKING_TYPES = BASE_URL + "/parking-types";

//LOGIN ACTIVITY (admin only)
export const GET_LOGIN_LOGS = BASE_URL + "/login-logs";
export const GET_LOGIN_LOGS_SUMMARY = BASE_URL + "/login-logs/summary";

export const POST_FAKE_JWT_PASSWORD_FORGET = "/jwt-forget-pwd";
export const SOCIAL_LOGIN = "/social-login";
